/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoldsRespondToChallengeRequest
 */
export interface HoldsRespondToChallengeRequest {
    /**
     * Response to challenge: 'confirm' to keep hold, 'release' to give it up
     * @type {string}
     * @memberof HoldsRespondToChallengeRequest
     */
    response: HoldsRespondToChallengeRequestResponseEnum;
}


/**
 * @export
 */
export const HoldsRespondToChallengeRequestResponseEnum = {
    Confirm: 'confirm',
    Release: 'release'
} as const;
export type HoldsRespondToChallengeRequestResponseEnum = typeof HoldsRespondToChallengeRequestResponseEnum[keyof typeof HoldsRespondToChallengeRequestResponseEnum];


/**
 * Check if a given object implements the HoldsRespondToChallengeRequest interface.
 */
export function instanceOfHoldsRespondToChallengeRequest(value: object): value is HoldsRespondToChallengeRequest {
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function HoldsRespondToChallengeRequestFromJSON(json: any): HoldsRespondToChallengeRequest {
    return HoldsRespondToChallengeRequestFromJSONTyped(json, false);
}

export function HoldsRespondToChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldsRespondToChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'response': json['response'],
    };
}

  export function HoldsRespondToChallengeRequestToJSON(json: any): HoldsRespondToChallengeRequest {
      return HoldsRespondToChallengeRequestToJSONTyped(json, false);
  }

  export function HoldsRespondToChallengeRequestToJSONTyped(value?: HoldsRespondToChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response': value['response'],
    };
}

